import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewEncapsulation, computed, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { UserProfileService } from 'app/modules/dashboard/dipita/user-profile/user-profile.service';

/**
 * Non-blocking reminder shown while key profile fields are missing.
 *
 * Completing the profile used to be a mandatory step gating the whole app; it is now done
 * from Settings whenever the user wants. This banner is the only thing left nudging them,
 * because those fields are what pre-fill their medical requests.
 */
@Component({
    selector: 'profile-reminder',
    standalone: true,
    imports: [NgIf, RouterLink, MatIconModule, MatButtonModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    template: `
        <div
            *ngIf="isIncomplete()"
            class="flex items-center gap-3 px-4 py-2.5 md:px-6 bg-amber-50 border-b border-amber-200 text-amber-900 print:hidden"
        >
            <mat-icon
                class="icon-size-5 text-amber-600 flex-shrink-0"
                [svgIcon]="'heroicons_outline:exclamation-triangle'"
            ></mat-icon>

            <div class="flex-auto text-sm leading-snug">
                Complétez votre profil pour accélérer vos demandes.
                <span class="hidden sm:inline text-amber-700">Il manque : {{ missingLabel() }}.</span>
            </div>

            <a
                class="flex-shrink-0 text-sm font-semibold underline whitespace-nowrap"
                [routerLink]="'/dashboard/profile'"
            >
                Compléter
            </a>
        </div>
    `,
})
export class ProfileReminderComponent {
    private readonly _userProfileService = inject(UserProfileService);

    readonly isIncomplete = this._userProfileService.isProfileIncomplete;

    readonly missingLabel = computed(() =>
        this._userProfileService.missingProfileFields().join(', ').toLowerCase()
    );
}
